<template>
    <main class="AboutUs-MAIN">
        <section>

            <h1>
                Nosotros
            </h1>

            <p>
                v 0.1
                <br/>17:44 GMT
            </p>

            <div>
                <div class="hide-scrollbar" @scroll="measureScroll">

                    AP(ART) es una plataforma operativa por casos para el desarrollo de proyectos de arte contemporáneo. No funciona como galería de representación ni como agencia. No administra trayectorias. Opera por proyecto.
                    <br/>
                    <br/>El trabajo se organiza en fases: investigación, producción, edición y mediación. El resultado no es el centro de la operación. El interés está en las condiciones que permiten su aparición y en las decisiones que lo estructuran: contexto, recursos, tiempos y restricciones.
                    <br/>
                    <br/>La plataforma opera como una estructura de soporte técnico. Activa relaciones funcionales entre artistas, espacios y agentes culturales según requerimientos específicos. No establece identidad formal ni continuidad estética.
                    <br/>
                    <br/>Se publican y disponen piezas, fragmentos de obra y materiales de trabajo como dispositivos de lectura. Su función es generar continuidad contextual entre proyectos, establecer relaciones y hacer legible el proceso. No operan como portafolio ni como exhibición.
                    <br/>
                    <br/>Un proyecto permanece activo únicamente mientras mantiene sus condiciones de operación. Si estas fallan, el proceso se interrumpe. Si se sostienen, el proyecto se completa y se archiva. No hay acumulación ni proyección de carrera.
                    <br/>
                    <br/>AP(ART) privilegia lenguaje instrumental, documentación mínima y trazabilidad operativa. El proceso y su evidencia tienen prioridad sobre la visibilidad del resultado.
                    
                </div>
            </div>

            <button @click="goToContact()">CONTACTO</button>

        </section>
    </main>
</template>

<script>
export default {
    name: 'SectionAboutUs',
    inject: ['vibrationScrollEnd'],
    data(){
        return{

        }
    },
    methods: {

        measureScroll(e){
            this.vibrationScrollEnd(e);
        },

        goToContact(){
            this.$router.push({ name: 'contact', params: { id: String(this.id) || null }, query: { from: 'about' } });
        }

    }
}
</script>

<style scoped lang="stylus">
.AboutUs-MAIN
    height: 100vh
    max-height: 100vh !important
    display: flex
    flex-direction: column
    align-items: center
    background-color: black

    >section
        background-color: white
        border-radius: 6vw
        margin: 2vw
        padding: 2vw 3vw
        height: calc(100% - 8vw)
        max-height: calc(100% - 8vw)
        width: calc(100% - 12vw)

        .AboutUs-arr-back
            max-width: 6vw
            max-height: 6vw
            position: fixed
            top: 4vw
            left: 4vw
            z-index 1

        h1
            margin-top: 1vw !important
            font-family: "Archivo ExtraCondensed", sans-serif
            font-size: 18vw
            margin-top: 1.5ch
            margin-bottom: 0
            border-bottom: 2px solid black

        >p
            color: #707070
            font-size: 3vw
            font-weight: 400
            font-family: "DM Mono", monospace
            margin-top: 8vw
            margin-bottom: -1.5vw

        >div
            position: relative
            mask-image: linear-gradient(to bottom, transparent 0%, white 10%, white 85%, transparent 100%)
            -webkit-mask-image: linear-gradient(to bottom, transparent 0%, white 10%, white 85%, transparent 100%)

            >div
                border-radius: 1ch
                font-family: "DM Mono", monospace
                padding: 4ch 0
                max-height: calc(100vh - 10vw - ((47px + 6vw + 6vw) * 2) - 8ch)
                overflow: auto
                font-size: 4vw
            
                blockquote
                    background-color: lightgray
                    border-left: 1ch solid #bbb
                    padding: 1ch 0
                    padding-left: 1ch
                    margin: 0
                    border-radius: 3px

        >button
            height: 47px
            width: calc(180px + 18px + 18px)
            background-color: rgb(1, 90, 255)
            color: white
            max-width: 75vw
            position: fixed
            margin: auto
            left: 0
            right: 0
            bottom: 6vw
            border-radius: 100vw
            z-index: 1
            font-family: "DM Mono", monospace
            border: none
</style>